var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 63,
    viewBox: "0 0 36 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9057 62.0573C13.6921 62.0573 9.46817 61.8541 5.27546 62.1146C1.16609 62.3698 -0.156835 60.6302 0.0619153 56.7291C0.29629 52.5312 0.0671233 48.3073 0.124415 44.0989C0.270249 33.5729 7.69734 26.0729 17.7755 26.2291C28.64 26.3958 35.739 33.4583 35.8692 44.2812C35.9213 48.4896 35.6713 52.7135 35.9369 56.9114C36.1921 61.0312 34.4265 62.3229 30.5359 62.1094C26.338 61.8802 22.1192 62.0573 17.9057 62.0573ZM17.3119 21.6354C11.9317 21.5677 7.99422 17.151 8.14526 11.3541C8.29109 5.66144 12.5307 0.880187 17.4473 0.869771C23.338 0.854145 28.7703 6.09373 28.6973 11.7291C28.6296 17.1198 23.3536 21.7083 17.3119 21.6354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/User icon.7f5dab9cbdd8f8ebfe8c739b84bd200e.svg";
export { ForwardRef as ReactComponent };